import React from 'react'
import PropTypes from 'prop-types'

import { Player } from 'video-react'

import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'

import ExternalLink from '@material-ui/icons/Launch'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

require('./../../../assets/styles/video.css')

const styles = {
  cardstyle: {
    padding: 5,
  },
  figcaption: {
    padding: 5
  },
  icon: {
    fontSize: 16,
  },
};

function VideoCard(props) {
  const { classes } = props;
  return (
    <Grid container spacing={10}>
      <Grid item xs={12}>
        <Paper className={classes.cardstyle}>
          <Player>
            <source src="https://wiki.instar.com/videos/INSTAR_Kamera_Tool_MacOS_Aufnahmen_der_SD_Karte_bequem_herunterladen.mp4" />
          </Player>
          <div className={classes.figcaption}>
            <p>Wir zeigen Ihnen in diesem Video das neue INSTAR Kamera Tool welches Sie ab sofort im App Store von MacOS finden. Auf <OutboundLink href="https://www.youtube.com/watch?v=CG0h7wD0spM" target="_blank" rel="noopener noreferrer">Youtube ansehen <ExternalLink className={classes.icon} /></OutboundLink></p>
          </div>
        </Paper>
      </Grid>
    </Grid>
  );
}

VideoCard.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(VideoCard)